import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { thunderstormCapabilitiesGroup } from '../../consts.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { LL_H_C, LL_V_L } from '../../components/Layouts/index.js';
import { TS_AppTools } from '../../components/TS_AppTools/index.js';
import './ATS_Printable.scss';
import { TS_PropRenderer } from '../../components/TS_PropRenderer/index.js';
import { Button } from '../../components/Button/Button.js';
import { ModuleFE_Print } from '../../modules/ModuleFE_Print.js';
import { TS_Printable } from '../../components/TS_Printable/index.js';
import { generateArray } from '@nu-art/ts-common';
export class ATS_Printable extends ComponentSync {
    sameContentRef = React.createRef();
    printableRef;
    static Screen = {
        key: 'ats-ts-printable',
        name: 'Printable',
        group: thunderstormCapabilitiesGroup,
        renderer: this,
    };
    render() {
        return _jsxs(LL_V_L, { id: 'ats__printable', children: [TS_AppTools.renderPageHeader('Printable'), _jsxs(LL_H_C, { className: 'ats__printable__printables', children: [this.render_Printable1(), this.render_Printable2(), this.render_Printable3()] })] });
    }
    render_Printable1 = () => {
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Same Content Printable', children: [_jsxs("div", { className: 'ats__printable__printable-content-wrapper', ref: this.sameContentRef, children: ["Expect to see this text in the print dialog!", generateArray(2, id => _jsx("img", { src: `https://picsum.photos/id/${id}/200/300`, alt: '' }, id))] }), _jsx(Button, { variant: 'primary', onClick: async () => {
                        const div = this.sameContentRef.current;
                        if (!div)
                            return;
                        await ModuleFE_Print.printElement(div);
                    }, children: "Print" })] });
    };
    render_Printable2 = () => {
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Different Content Printable', children: [_jsx("div", { className: 'ats__printable__printable-content-wrapper', children: "Expect to see something else in the print dialog" }), _jsx(Button, { variant: 'primary', onClick: () => ModuleFE_Print.printNode(this.differentContentRenderer()), children: "Print" })] });
    };
    render_Printable3 = () => {
        return _jsxs(TS_PropRenderer.Vertical, { label: 'With TS Printable', children: [_jsx(TS_Printable, { className: 'ats__printable__printable-content-wrapper', printable: async (ref) => {
                        this.printableRef = ref;
                    }, children: "Expect to see this text in the print dialog!" }), _jsx(Button, { variant: 'primary', onClick: () => ModuleFE_Print.printElement(this.printableRef), children: "Print" })] });
    };
    differentContentRenderer = () => {
        const urls = generateArray(200, id => _jsx("img", { src: `https://picsum.photos/id/${id}/200/300`, alt: '' }, id));
        return _jsx(LL_V_L, { children: urls });
    };
}
//# sourceMappingURL=ATS_Printable.js.map